import { useQuery } from 'react-query';

import { GetSubsetFactAllIdsResponse } from '../../../../backend/src/matter/subset/dto/response-get-subset.facts.dto';
import { FactFilters } from '../../types';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';
import { createFilterBody } from '@/helpers/createFilterParams';

interface GetSubsetFactAllIdsProps {
  matterId: string;
  subsetId: string;
  searchQuery?: string;
  filters: FactFilters;
  enabled?: boolean;
}

function useGetSubsetFactAllIds({
  matterId,
  subsetId,
  searchQuery,
  filters,
  enabled = false,
}: GetSubsetFactAllIdsProps) {
  const { getFetchConfig } = useGetFetchConfig();
  const fetchConfigPOST = getFetchConfig({
    method: FetchMethod.POST,
    data: {
      searchQuery: searchQuery || '',
      paginated: false,
      ...createFilterBody(filters),
    },
  });

  return useQuery<GetSubsetFactAllIdsResponse, Error>(
    [QueryEntity.SubsetFactAllIds, { subsetId, searchQuery, filters }],
    async () => {
      const response = await fetch(`${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/fact/fact-ids`, {
        ...fetchConfigPOST,
      });
      if (!response.ok) throw new Error('Network response was not ok');
      return response.json();
    },
    {
      enabled,
      refetchOnWindowFocus: false,
    },
  );
}

export default useGetSubsetFactAllIds;
